
import { Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MonthlyRevenue } from "@models/monthly-revenue";
import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { DateTime } from "luxon";
import { SkeletonModule } from "primeng/skeleton";
import { DashboardCardComponent } from "../../../../cards/dashboard-card/dashboard-card.component";

@Component({
    selector: "app-revenue-graphic-card",
    imports: [
    DashboardCardComponent,
    MatIconModule,
    SkeletonModule
],
    templateUrl: "./revenue-graphic-card.component.html",
    styleUrl: "./revenue-graphic-card.component.scss"
})
export class RevenueGraphicCardComponent {
  private _revenue: MonthlyRevenue[] | null = null;
  @Input({ required: true }) set revenue(revenue: MonthlyRevenue[] | null) {
    this._revenue = revenue;
    this.updateChart();
  }
  get revenue() {
    return this._revenue;
  }
  chart?: Chart;

  updateChart() {
    if (this.revenue)
      this.chart = new Chart("canvas", {
        type: "bar",
        data: {
          labels: this.revenue.map((dataEntry) =>
            DateTime.fromFormat(dataEntry.month, "yyyy-MM")
              .setLocale("pt-BR")
              .toFormat("LLL/yy")
              .toUpperCase(),
          ),
          datasets: [
            {
              label: "Faturamento",
              data: this.revenue.map((dataEntry) => dataEntry.value),
              borderWidth: 2,
              backgroundColor: "#00c6e3",
              hoverBackgroundColor: "#7c0084",
              borderSkipped: true,
            },
          ],
        },

        plugins: [ChartDataLabels],
        options: {
          plugins: {
            legend: {
              position: "bottom",
            },
            datalabels: {
              anchor: "end",
              align: "top",
              font: {
                weight: "bold",
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
  }
}
